import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ShareLinksPage, type ShareLinksSearchState } from '../features/sharing/share-links-page';

const SharesSearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  status: z.enum(['ACTIVE', 'EXPIRED', 'REVOKED']).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/',
)({ component: SharesRoute, validateSearch: zodValidator(SharesSearchSchema) });

function SharesRoute() {
  const params = Route.useParams();
  const searchState: ShareLinksSearchState = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ShareLinksPage
      {...params}
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      searchState={searchState}
    />
  );
}
